<template>
  <div class="modal__cover" @click.self="onClickModalCover">
    <div class="modal__content">
      <div class="modal__descriptions">
        <div class="modal__text">
          <div class="modal__text__title">
            <span>{{ titleText }}</span>
          </div>
          <div class="modal__text__caption">
            <span>{{ captionText }}</span>
          </div>
        </div>
        <div class="modal__btn">
          <div class="modal__btn--primary">
            <button
              type="button"
              class="btn btn--primary"
              style="margin: 0"
              :disabled="primaryButtonDisabled || null"
              @click="onClickPrimaryButton"
            >
              {{ primaryButtonText }}
            </button>
          </div>
          <div class="modal__btn--cancel">
            <span @click="onClickCancelButton">{{ cancelButtonText }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titleText: {
      type: String,
      required: true
    },
    captionText: {
      type: String,
      required: true
    },
    primaryButtonText: {
      type: String,
      required: true
    },
    cancelButtonText: {
      type: String,
      required: true
    },
    primaryButtonDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    onClickModalCover() {
      this.$emit('clicked-modal-cover')
    },
    onClickPrimaryButton() {
      this.$emit('clicked-primary')
    },
    onClickCancelButton() {
      this.$emit('clicked-cancel')
    }
  }
}
</script>
